import { App, InjectionKey, inject } from 'vue'

import { QueryPersisterMap } from './server-setup'
import { PersisterCardinality } from './shared'

const QUERY_PERSISTER_MAP_KEY: InjectionKey<QueryPersisterMap | undefined> = Symbol('query-persister-map')

export const createQueryPersisterPlugin = (persisters: QueryPersisterMap | undefined) => {
    return {
        install(app: App) {
            app.provide(QUERY_PERSISTER_MAP_KEY, persisters)
        },
    }
}

/**
 * Hook to get persister function for a specific cardinality tier
 * Usage: persister: usePersisterFn(Persisters.LowCardinality)
 */
export const usePersisterFn = (tier: PersisterCardinality) => {
    const persisters = inject(QUERY_PERSISTER_MAP_KEY)
    return persisters?.[tier]?.persister.persisterFn
}
